<template>
  <div :style="cstyle" ref="map"></div>
</template>

<script>
import leaflet from "../utils/leaflet";

let L;

export default {
  name: "LocationsMap",

  props: ["geojson", "locations"],

  data() {
    return {
      url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      map: null,
      center: [47.754067, 9.091346],
      zoom: 11,
      height: 30,
      geojsonLayer: null,
      locationsCache: {}
    };
  },

  computed: {
    cstyle() {
      const s = {};
      s.height = this.height + "rem";
      s.zIndex = 1;

      return s;
    },
  },

  mounted() {
    if (window.outerWidth < 576) {
      this.height = 20;
      this.zoom = 10;
    }

    L = leaflet;

    this.map = L.map(this.$refs.map);

    const basemap = L.tileLayer(this.url, {
      attribution: "OpenStreetMap-Mitwirkende"
    });

    basemap.addTo(this.map);

    this.map.setView(this.center, this.zoom);

    this.map.scrollWheelZoom.disable();

    this.loadGeojson();
  },

  watch: {
    locations(locations) {
      locations.forEach(location => {
        if (location.active != this.locationsCache[location.locationId]) {
          const layer = this.geojsonLayer.getLayer(location.locationId);
          if (!layer) {
            if (location.children.length == 0) {
              console.log("layer locationId=" + location.locationId + " not found");
            }
          } else {
            if (location.active) {
              this.select(layer, location.locationId, true);
            } else {
              this.unselect(layer, location.locationId, true);
            }
          }
        }
      });
    }
  },

  methods: {
    getLocation(locationId) {
      return this.locations.find(location => location.locationId == locationId);
    },

    loadGeojson() {
      const inst = this;

      this.geojsonLayer = L.geoJSON(this.geojson, {
        style: () => {
          return {
            fillColor: "",
            weight: 2,
            color: '#666',
            fillOpacity: 0
          };
        },
        onEachFeature(feature, layer) {
          layer._leaflet_id = feature.properties.locationId;

          inst.locationsCache[feature.properties.locationId] = false;

          const location = inst.getLocation(feature.properties.locationId);
          if (location && location.active) {
            inst.select(layer, feature.properties.locationId);
          }

          layer.on({
            /*
            mouseover: (e) => {
              inst.mouseover(feature);
            },
            mouseout: (e) => {
              inst.mouseout(feature);
            },
            */
            click: (e) => {
              inst.$emit("click", inst.getLocation(feature.properties.locationId));
            }
          });
        }
      }).addTo(this.map);
    },

    select(layer, locationId, mapAction) {
      this.locationsCache[locationId] = true;
      layer.setStyle({
        fillColor: this.$vuetify.theme.currentTheme.primary,
        weight: 1,
        opacity: 1,
        color: 'white',
        fillOpacity: 0.7
      });

      if (mapAction) {
        //this.map.fitBounds(layer.getBounds());
        layer.bringToFront();
      }
    },

    unselect(layer, locationId, mapAction) {
      this.locationsCache[locationId] = false;
      this.geojsonLayer.resetStyle(layer);

      if (mapAction) {
        layer.bringToFront();
      }
    },
/*
    click(location) {
      console.log(location);
      const layer = this.geojsonLayer.getLayer(location.properties.locationId);

      this.map.fitBounds(layer.getBounds());

      if (!layer.feature.properties.active) {
        layer.feature.properties.active = true;
        this.select(layer);
        layer.bringToFront();
      } else {
        layer.feature.properties.active = false;
        this.unselect(layer);
      }
    },

    mouseover(location) {
      const layer = this.geojsonLayer.getLayer(location.properties.locationId);

      if (!layer.feature.properties.active) {
        layer.setStyle({
            fillColor: "",
            weight: 3,
            color: '#666',
            fillOpacity: 0
        });

        layer.bringToFront();
      }
    },

    mouseout(location) {
      const layer = this.geojsonLayer.getLayer(location.properties.locationId);

      if (!layer.feature.properties.active) {
        this.geojsonLayer.resetStyle(layer);
      }
    }
*/
  }
};
</script>
